import { createReducer } from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { all } from 'redux-saga/effects'
import { Entity } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'productTag';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
